import lokiDB from "./lokiDB";
import {
    getModificationTime,
    insertInto,
    setModificationTime,
} from "../utils/LokiUtils";

class BreedingCountersDB {
    collectionName = "breedingCounters";

    getModificationTime(FarmID) {
        return getModificationTime(this.collectionName, "FarmID", FarmID);
    }

    /**
     * Data modyfikacji trzymana jest per ferma - patrz komentarz w salesDB.insertSales
     * @param values tablica licznikow
     */
    insertBreedingCounters(values) {
        values.sort((e1, e2) => e1.DtaModTime - e2.DtaModTime);
        insertInto(values, lokiDB.breedingCounters, "CntID");
        const newest = values[values.length - 1];
        setModificationTime(
            this.collectionName,
            newest.DtaModTime,
            "FarmID",
            newest.FarmID
        );
    }

    getBreedingCounters(FarmID) {
        return lokiDB.breedingCounters.find({
            FarmID,
            DtaDelTime: {$type: "undefined"},
        });
    }

    getBreedingCountersByRace(FarmID, Race) {
        return lokiDB.breedingCounters.find({
            FarmID,
            Race,
            DtaDelTime: {$type: "undefined"},
        });
    }
}

const breedingCountersDB = new BreedingCountersDB();
export default breedingCountersDB;
